<template>
    <div class="my-autocomplete">
        <b-row v-if="!!label">
            <b-col cols="12"
                ><label for="">{{ label }}</label></b-col
            >
        </b-row>
        <b-row class="no-gutters">
            <b-col cols="11">
                <b-form-input
                    class="group-text-field"
                    autocomplete="off"
                    @input="handleSearch"
                    :ref="id"
                    @keyup.native.down="down"
                    @keyup.native.up="up"
                    @keyup.native.enter="enter"
                    @blur.native="releaseFocus('text')"
                    @focus.native="setFocus('text')"
                    :placeholder="placeholder"
                    :value="!!value ? value[labelProp] : ''"
                    :disabled="disabled"
                />
                <span class="field-error" v-if="hasError">{{
                    errorMessage
                }}</span>
            </b-col>
            <b-col cols="1">
                <b-btn
                    :disabled="disabled"
                    variant="primary"
                    class="group-button"
                    @click="openResults"
                    @blur="getAway('button')"
                >
                    <i v-if="!showResults" class="fa fa-chevron-down"></i>
                    <i v-else class="fa fa-chevron-up"></i>
                </b-btn>
            </b-col>
        </b-row>
        <div
            class="results-container"
            v-if="showResults"
            :style="{ top: !!label ? '70px' : '38px' }"
        >
            <ul class="results-list">
                <li
                    v-for="(item, i) in results"
                    @click="setResult(i)"
                    :key="i"
                    class="p-2 result-item"
                    :class="{
                        'bg-secondary': i === index,
                        'text-white': i === index,
                    }"
                    v-html="highlight(item[resultsProp], search)"
                ></li>
            </ul>
        </div>
    </div>
</template>
<script>
const normalize = str =>
    str.toLowerCase().replace(/[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g, '')
const getProp = (obj, prop) => {
    if (
        !obj ||
        typeof obj.constructor() !== 'object' ||
        !obj.hasOwnProperty(prop)
    )
        return ''

    return obj[prop]
}
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        id: {
            type: String,
            default: () => `autocomplete-${parseInt(Math.random() * 10000)}`,
        },
        placeholder: {
            type: String,
            default: '',
        },
        keyProp: {
            type: String,
            default: 'id',
        },
        labelProp: {
            type: String,
            default: 'name',
        },
        resultsProp: {
            type: String,
            default: 'name',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        value: {},
        disabled: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            search: '',
            showResults: false,
            index: -1,
            selectedResult: null,
            currentFocus: '',
        }
    },
    watch: {
        value(val) {
            this.search = val[this.labelProp]
        },
        items(val) {
            if (!!this.value && this.items.length) {
                const index = this.items.findIndex(
                    item => item.id === this.value.id
                )
                if (-1 !== index) {
                    this.index = index
                    this.enter()
                }
            }
        },
    },
    computed: {
        results() {
            if (!this.search) return this.items

            const results = this.items.filter(
                item =>
                    item.name.toLowerCase().search(this.search.toLowerCase()) !=
                    -1
            )

            return results
        },
    },
    methods: {
        handleSearch(val) {
            if (!val) {
                this.reset()
                this.$emit('input', this.selectedResult)
                this.$emit('change', this.selectedResult)
            }

            this.search = val
            this.checkResults()
        },
        checkResults() {
            this.showResults = !!this.results.length && !!this.search

            if (this.results.length === 1) {
                this.index = 0
            }
        },
        openResults() {
            this.currentFocus = 'button'
            this.reset()
            this.$refs[this.id].focus()
            this.$refs[this.id].select()
            // this.$nextTick(() => {
            // setTimeout(() => {
            this.showResults = true
            // }, 100);

            // });
        },
        reset() {
            this.search = ''
            this.index = -1
            this.selectedResult = ''
        },
        down() {
            this.index = Math.min(this.results.length - 1, this.index + 1)
        },
        up() {
            this.index = Math.max(0, this.index - 1)
        },
        enter() {
            if (this.index < 0 || this.index >= this.results.length) return

            this.selectedResult = this.results[this.index]

            this.search = getProp(this.selectedResult, this.labelProp)

            // this.getAway();

            // this.hideResults();

            // this.currentFocus = '';

            this.releaseFocus()

            this.$emit('input', this.selectedResult)
            this.$emit('change', this.selectedResult)
        },
        setResult(index) {
            this.index = index
            this.enter()
        },
        getAway(control) {
            setTimeout(() => {
                // (!!this.selectedResult) && (this.search = this.selectedResult.name);
                ;(!['text', 'button'].includes(this.currentFocus) ||
                    this.currentFocus === control) &&
                    (this.showResults = false)
                this.index = -1
            }, 200)
        },
        highlight(text, part) {
            const index = text.toLowerCase().search(part.toLowerCase())

            if (-1 === index) return text

            return (
                text.substring(0, index) +
                '<span style="font-weight: bold; background-color: yellow; color: black;">' +
                text.substring(index, index + part.length) +
                '</span>' +
                text.substring(index + part.length)
            )
        },
        setFocus(el) {
            this.currentFocus = el
            switch (el) {
                case 'text':
                    this.openResults()
                    break
            }
        },
        releaseFocus(el = '') {
            this.currentFocus = ''
            // this.getAway(el);

            if (!this.currentFocus) {
                setTimeout(() => {
                    this.hideResults()
                }, 200)
            }
            // this.hideResults();
        },
        hideResults() {
            this.index = -1
            this.showResults = false
        },
    },
    mounted() {
        if (!!this.value) {
            const index = this.results.findIndex(item => item.id === this.value)
            if (-1 === index) return

            this.index = index
            this.enter()
        }
    },
}
</script>
<style scoped>
.my-autocomplete {
    position: relative;
    max-width: 90%;
}
.group-text-field {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.group-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.results-list {
    list-style: none;
    background-color: white;
    width: 100%;
    /* border-bottom-left-radius: 6px; */
    /* border-bottom-right-radius: 6px; */
    /* border-left: 1px solid lightgray; */
    /* border-bottom: 1px solid lightgray; */
    /* border-right: 1px solid lightgray; */
}
.result-item {
    cursor: pointer;
    border-bottom: 1px solid lightgray;
}

.result-item :not(:last-child) {
    border-bottom: 1px solid lightgray;
}

.result-item:hover {
    background-color: #6a757e;
    color: white;
}

.results-container {
    position: absolute;
    left: 0;
    z-index: 999;
    max-height: 250px;
    overflow-y: auto;
    border-left: 2px solid lightgray;
    border-right: 2px solid lightgray;
    border-bottom: 2px solid lightgray;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    padding-bottom: 0;
    background-color: white;
    width: 100%;
}
</style>
